export const SHOW_ALL_CASES = 'all';
export const SHOW_OPEN_CASES = 'open';
export const SHOW_CLOSED_CASES = 'closed';
export const SHOW_PAUSED_CASES = 'paused';
export const PAUSE_CASES = 'pause';
export const RESUME_CASES = 'resume';
